import { render, staticRenderFns } from "./CanvaMap.vue?vue&type=template&id=2365122e&scoped=true&"
import script from "./CanvaMap.vue?vue&type=script&lang=js&"
export * from "./CanvaMap.vue?vue&type=script&lang=js&"
import style0 from "./CanvaMap.vue?vue&type=style&index=0&id=2365122e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2365122e",
  null
  
)

export default component.exports